export const staticPaths = {
    account: {
        pathname: '/account',
    },
    accountOrganization: {
        pathname: '/account/organization',
    },
    accountOrganizationMember: {
        pathname: '/account/organization/member',
    },
    accountOrganizationAdmin: {
        pathname: '/account/organization',
    },
    accountChannel: {
        pathname: '/account/channel',
    },
    accountChannelFollow: {
        pathname: '/account/channel?type=follow',
    },
    accountChannelAdmin: {
        pathname: '/account/channel',
    },
    accountSettings: {
        pathname: '/account/settings',
    },
    createOrganization: {
        pathname: '/create-organization',
        state: {
            isModal: true,
        },
    },
    createChannel: {
        pathname: '/create-channel',
        state: {
            isModal: true,
        },
    },
    createEvent: {
        pathname: '/create-event',
        state: {
            isModal: true,
        },
    },
    login: {
        pathname: '/login',
        state: {
            isModal: true,
        },
    },
    register: {
        pathname: '/register',
        state: {
            isModal: true,
        },
    },
    select_category: {
        pathname: '/select-category',
    },
    category: {
        pathname: '/category',
    },
    logout: {
        pathname: '/logout',
        search: '',
        state: {
            isModal: true,
        },
    },
    root: {
        pathname: '/',
    },
    home: {
        pathname: '/home',
    },
    myspace: {
        pathname: '/myspace',
    },
    workspace: {
        pathname: '/workspace',
    },
    workspacePlatform: {
        pathname: '/platform-hub',
    },
    discovery: {
        pathname: '/discovery',
    },
    apps: {
        pathname: '/apps',
    },
    bookmark: {
        pathname: '/bookmark',
    },
    myBookmarks: {
        pathname: '/my-bookmarks',
    },
    myActivities: {
        pathname: '/my-activities',
    },
    myChannels: {
        pathname: '/my-channels',
    },
    myArticles: {
        pathname: '/account/articles',
    },
    start: {
        pathname: '/start',
    },
    welcome: {
        pathname: '/welcome',
    },
    about: {
        pathname: '/helps/about-us',
    },
    policy: {
        pathname: '/helps/privacy-policy',
    },
    tutorials: {
        pathname: '/helps/tutorials',
    },
    messages: {
        pathname: '/messages',
    },
    selectPrimaryOrganization: {
        pathname: '/select-primary-organization',
        state: {
            isModal: true,
        },
    },
    search: {
        pathname: '/search',
    },
    calendar: {
        pathname: '/calendar',
    },
    liturgical: {
        pathname: '/liturgical',
    },
    churches: {
        pathname: '/churches',
    },
    massTimes: {
        pathname: '/mass-times',
    },
    dioceses: {
        pathname: '/dioceses',
    },
    religiousOrder: {
        pathname: '/religious-orders',
    },
    yellowPages: {
        pathname: '/yellow-pages',
    },
    missals: {
        pathname: '/missals',
    },
    profiles: {
        pathname: '/profiles',
    },
    saints: {
        pathname: '/saints',
    },
    prelates: {
        pathname: '/prelates',
    },
    bibles: {
        pathname: '/bibles',
    },
    feedbacks: {
        pathname: '/feedbacks',
    },
    feedbackRequests: {
        pathname: '/feedbacks/add-request',
    },
    organizations: {
        pathname: '/organizations',
    },
    products: {
        pathname: '/products',
    },
    groups: {
        pathname: '/groups',
    },
    prayers: {
        pathname: '/prayers',
    },
    courses: {
        pathname: '/courses',
    },
    musics: {
        pathname: '/musics',
    },
    hymns: {
        pathname: '/hymns',
    },
    asks: {
        pathname: '/asks',
    },
    examinations: {
        pathname: '/examinations',
    },
    dictionaries: {
        pathname: '/dictionaries',
    },
    definitions: {
        pathname: '/definitions',
    },
    ecclesiasticDocument: {
        pathname: '/ecclesiastics',
    },
    catholicHouseholds: {
        pathname: '/catholic-households',
    },
    liturgies: {
        pathname: '/liturgies',
    },
    turnToChrist: {
        pathname: '/journey-to-christ',
    },
    evangelization: {
        pathname: '/evangelization',
    },
    pilgrimage: {
        pathname: '/pilgrimage',
    },
    prayerBooks: {
        pathname: '/prayer-books'
    },
    spiritualPath: {

        pathname: '/spiritual-path'
    },
    spiritualExamen: {
        pathname: '/spiritual-examen'
    },
    spiritualJournal: {
        pathname: '/spiritual-journal'
    },
    spiritualDiscernment: {
        pathname: '/spiritual-discernment'
    },
    spiritualExercises: {
        pathname: '/spiritual-exercises'
    },
    devotions: {
        pathname: '/devotions'
    },
    devotionDetail: {
        pathname: '/devotion/:id'
    },
    prayerMethods: {
        pathname: '/prayer-methods'
    },
    prayerMethodDetail: {
        pathname: '/prayer-methods/:id'
    },
    news: {
        pathname: '/news',
    },
}

export const staticUrls = {
    CatechismQuiz: {
        pathname: '/examination/trac-nghiem-ve-giao-ly-du-tong-1757058363',
    },
    QuizEvangelization: {
        pathname: '/examination/trac-nghiem-ve-su-vu-loan-bao-tin-mung-1757058189',
    },

}